export default __webpack_public_path__ + "static/champions-of-change-baf5d893df1f2d5a9a5883e2af42e57f.mp4";